module.exports = __webpack_public_path__ + "img/auditFail.2cf7a52e.png";